// src/components/products/ProductForm/GeneralInfoSections/BasicClassificationSection.jsx

import React from "react";
import { Grid } from "@mui/material";
import FormInput from "../../../inputs/FormInput";

const BasicClassificationSection = ({
    formData,
    setFormData,
    errors,
    isArabic,
    categoriesOptions,
    transportationsOptions,
    loadingCategories,
    loadingTransportations,
}) => {
    return (
        <Grid container spacing={3}>
            {/* Category */}
            <Grid item xs={12} md={6}>
                <FormInput
                    label={isArabic ? 'التصنيف' : 'Category'}
                    type="select"
                    name="category_id"
                    value={formData.category_id || ''}
                    onChange={(e) =>
                        setFormData({ ...formData, category_id: e.target.value })
                    }
                    required
                    disabled={loadingCategories}
                    error={!!errors.category_id}
                    helperText={errors.category_id}
                    options={categoriesOptions}
                />
            </Grid>

            {/* Transportation */}
            <Grid item xs={12} md={6}>
                <FormInput
                    label={isArabic ? 'وسيلة النقل' : 'Transportation'}
                    type="select"
                    name="transportation_id"
                    value={formData.transportation_id || ''}
                    onChange={(e) =>
                        setFormData({ ...formData, transportation_id: e.target.value })
                    }
                    required
                    disabled={loadingTransportations}
                    error={!!errors.transportation_id}
                    helperText={errors.transportation_id}
                    options={transportationsOptions}
                />
            </Grid>
        </Grid>
    );
};

export default BasicClassificationSection;
